var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5303 13.4697C15.8232 13.7626 15.8232 14.2374 15.5303 14.5303L13.0607 17L15.5303 19.4697C15.8232 19.7626 15.8232 20.2374 15.5303 20.5303C15.2374 20.8232 14.7626 20.8232 14.4697 20.5303L12 18.0607L9.53033 20.5303C9.23744 20.8232 8.76256 20.8232 8.46967 20.5303C8.17678 20.2374 8.17678 19.7626 8.46967 19.4697L10.9393 17L8.46967 14.5303C8.17678 14.2374 8.17678 13.7626 8.46967 13.4697C8.76256 13.1768 9.23744 13.1768 9.53033 13.4697L12 15.9393L14.4697 13.4697C14.7626 13.1768 15.2374 13.1768 15.5303 13.4697Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V7.25H2V5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.75V15C2 16.1046 2.89543 17 4 17H8.81802L7.40901 15.591C6.53033 14.7123 6.53033 13.2877 7.40901 12.409C8.28769 11.5303 9.71231 11.5303 10.591 12.409L12 13.818L13.409 12.409C14.2877 11.5303 15.7123 11.5303 16.591 12.409C17.4697 13.2877 17.4697 14.7123 16.591 15.591L15.182 17H20C21.1046 17 22 16.1046 22 15V8.75H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardDelete);
export default __webpack_public_path__ + "static/media/credit-card-delete.4ab4b8ee825e471855dc9245894878b2.svg";
export { ForwardRef as ReactComponent };